import {
  COLOR_FROM_STRING_HUE_RANGE,
  COLOR_FROM_STRING_LIGHTNESS,
  COLOR_FROM_STRING_SATURATION,
} from './constants';

// Stable numeric hash from a string so the same input always maps to the same color.
const hashString = (str: string): number =>
  [...str].reduce((hash, char) => {
    const codePoint = char.codePointAt(0) ?? 0;
    // Bit shift mixes prior hash bits with the next code point.
    // eslint-disable-next-line no-bitwise
    return codePoint + ((hash << 5) - hash);
  }, 0);

const generateColorFromString = (
  str: string,
  saturation: number = COLOR_FROM_STRING_SATURATION,
  lightness: number = COLOR_FROM_STRING_LIGHTNESS
): string => {
  // HSL hue is an angle in degrees, so keep the hash within [0, 360).
  const hue = Math.abs(hashString(str)) % COLOR_FROM_STRING_HUE_RANGE;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export default generateColorFromString;
